import { MutationTuple, gql, useMutation } from '@apollo/client';
import { DeleteInvitationInput, SendInvitationOutput } from './types';

const DELETE_INVITATION_MUTATION = gql`
  mutation deleteInvitation($details: ApiDeleteInvitationInput!) {
    sendInvitation: deleteInvitation(details: $details) {
      message
    }
  }
`;

export function useDeleteInvitationMutation(): MutationTuple<
  SendInvitationOutput,
  DeleteInvitationInput
> {
  return useMutation<SendInvitationOutput, DeleteInvitationInput>(
    DELETE_INVITATION_MUTATION,
  );
}
